<div class="service-request-wrapper">
    <app-custom-tabs [tabs]="tabs" [activeTabId]="activeTabId" (tabClicked)="onTabClicked($event)" />
    <div class="gap py-8"></div>
    <router-outlet />
</div>